import Service from './service';
import {AxiosRequestConfig, AxiosResponse} from 'axios';

const Config = require('Config');

interface ForgotPasswordArgs {
  email: string;
  sendSms: boolean;
}

interface ChangePasswordArgs {
  newPassword: string;
  token: string;
}

class SentinelService extends Service {
  constructor() {
    super(Config.sentinelServiceUrl);
  }

  async createSignupToken(args): Promise<any> {
    const url = `/token`;

    const response: AxiosResponse = await this.axios.post(url, args);
    if (!response || response.status !== 200) {
      throw new Error();
    }
    return response.data;
  }

  async forgotPassword(args: ForgotPasswordArgs): Promise<{phone: string}> {
    const url = `/user/forgot_password`;

    const config: AxiosRequestConfig<never> = {
      params: {
        ...( args.sendSms && { send_sms: args.sendSms }),
      },
    };

    const response: AxiosResponse = await this.axios.post(url, { email: args.email }, config);
    if (!response || response.status !== 200) {
      throw new Error('Failed to send forgot password request');
    }
    return response.data;
  }

  async changePassword(args: ChangePasswordArgs): Promise<void> {
    this.skipLogout = true;
    const url = '/user/change_password';

    const response: AxiosResponse = await this.axios.post(url, {
      newPassword: args.newPassword,
      access_token: args.token });

    if (!response || response.status !== 200) {
      throw new Error('Failed to change password');
    }
  }
}
export default new SentinelService();
